import _extends from "@babel/runtime/helpers/extends";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Chip, Grid, styled, Tooltip, Typography } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import React, { useEffect } from "react";
import { ListPagePhoneIcon } from '../../../assets/customIcons';
import { MoreIconNew, RightArrowIconBlue } from "../../../assets/images";
import { MuiButton } from "../../../components";
import { MuiAvatar } from "../../../components/atoms/avatarComponent";
import { MuiIconButton } from "../../../components/atoms/iconButtonComponent";
import { MuiStack } from "../../../components/atoms/stackComponent";
import { Timer } from "../../../components/templates/timerComponent";
import { EListCardView, ESystemName, JC_ALERT_TYPES, LOCAL_STORAGE_KEYS, StatusEnum, steps } from "../../../constants";
import { getStatusColor } from "../../../theme/statusColors";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import useAnalyticsEventTracker from "../../../utils/useAnalyticsEventTracker";
import { checkIfBetweenNowAndContdownTime, dateFormate, getTime, getTimeString, handleMobileNoPhoneCall } from "../../../utils/utils";
import { bajajPrimaryBlue } from "../../../theme/palette";
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "20px",
        marginRight: "5px",
        width: "20px"
    };
});
export default function ListCard(props) {
    var _data$Customer, _data$Customer2, _data$Customer3, _data$Customer4, _data$ETDDateTime, _data$Alerts;
    var data = props.data, onCardClick = props.onCardClick, handleClick = props.handleClick, isMoreMenuVisible = props.isMoreMenuVisible, parentComponent = props.parentComponent, menusFeatures = props.menusFeatures, showViewDetailsButton = props.showViewDetailsButton;
    var trackButtonClick = useAnalyticsEventTracker("ListCard");
    var deliveryDate = data.DeliveryDate;
    var _a = React.useState(0), seconds = _a[0], setSeconds = _a[1];
    var _b = React.useState(true), isOpen = _b[0], setIsOpen = _b[1];
    var handleTimerCallback = function (s) {
        setSeconds(s);
    };
    useEffect(function () {
        startTimer();
        // checkDelayCondition()
    }, []);
    var startTimer = function () {
        if (moment(deliveryDate).isBefore(moment())) {
            var secondsPassedToDeliveryTime = moment().diff(moment(deliveryDate), "seconds");
            setSeconds(secondsPassedToDeliveryTime);
        }
        else if (moment(deliveryDate).isAfter(moment())) {
            var secondsRemainingForDeliveryTime = moment().diff(moment(deliveryDate), "seconds");
            setSeconds(secondsRemainingForDeliveryTime);
        }
    };
    var delayJobCardConfig = getLocalStorageItem(LOCAL_STORAGE_KEYS.DELAY_JOB_CARD_CONFIGURATION);
    var statusList = getLocalStorageItem(LOCAL_STORAGE_KEYS.STATUS_LIST);
    var getShowTimerCondition = function (row) {
        if (delayJobCardConfig) {
            if (!delayJobCardConfig.IsDelayCountDown) {
                return false;
            }
            var AfterTimeMinutes = delayJobCardConfig.AfterTimeMinutes ? delayJobCardConfig.AfterTimeMinutes : 0;
            var CountdownTimeInSeconds = delayJobCardConfig.CountdownTimeMinutes ? delayJobCardConfig.CountdownTimeMinutes * 60 : 0;
            var statusValidate = true;
            if (delayJobCardConfig && delayJobCardConfig.StatusKey) {
                var minStep = steps.findIndex(function (item) { return item.key === delayJobCardConfig.StatusKey; });
                var currentStep = steps.findIndex(function (item) { return item.key === row.Key; });
                statusValidate = minStep > currentStep;
            }
            var afterTimeDate = moment(row.deliveryDate).add(AfterTimeMinutes, 'minutes');
            if (moment().isBefore(afterTimeDate)) {
                var countDownTimerValidate = false;
                if (checkIfBetweenNowAndContdownTime(CountdownTimeInSeconds, afterTimeDate)) {
                    // Configurable Countdown time check
                    countDownTimerValidate = true;
                }
                return statusValidate && countDownTimerValidate;
            }
            else {
                var afterTimeValidate = true;
                var difference = moment().diff(moment(row.deliveryDate), 'minutes');
                afterTimeValidate = difference >= AfterTimeMinutes;
                return statusValidate && afterTimeValidate;
            }
        }
        else {
            return false;
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, parentComponent === ESystemName.Jobcard && getShowTimerCondition(data) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            backgroundColor: "".concat(seconds)[0] === '-' ? '#FFF7E5' : '#FFF1F0',
            width: '148px',
            height: '20px',
            margin: '-9px 0px 0px -10px',
            position: 'absolute',
            alignItems: 'center',
            borderRadius: '4px 4px 4px 0px',
            padding: '0px 8px 2px 8px',
            border: "1px solid ".concat("".concat(seconds)[0] === '-' ? '#FFDD99' : '#FFA39E')
        }
    }, /*#__PURE__*/ React.createElement(Timer, {
        timing: seconds,
        callback: handleTimerCallback
    })), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            margin: '11px 0px 0px -10px',
            position: 'absolute',
            zIndex: 1,
            alignItems: 'center',
            width: 0,
            height: 0,
            borderLeft: '10.5px solid transparent',
            borderRight: '0px solid transparent',
            borderTop: "13.5px solid ".concat("".concat(seconds)[0] === '-' ? '#FFCD5D' : '#ED9B9F')
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        sx: {
            border: "1px solid #DEE4EB",
            borderRadius: "12px",
            backgroundColor: '#FFFFFF'
        },
        padding: "12px",
        id: 'card'
        // onClick={onCardClick}
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        onClick: function () {
            onCardClick();
        },
        spacing: 1,
        direction: "column",
        width: "100%"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        width: '70%'
    }, EListCardView.Appointment == parentComponent && /*#__PURE__*/ React.createElement(MuiAvatar, {
        sx: {
            marginRight: "7px",
            position: 'static',
            width: '32px',
            height: '32px'
        }
    }), EListCardView.Appointment == parentComponent ? /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        alignItems: "start"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'medium',
        id: "given-name",
        sx: {
            textTransform: 'capitalize'
        }
    }, "".concat(data !== null && data !== void 0 && data.GivenName ? data === null || data === void 0 ? void 0 : data.GivenName : "-", " ").concat(data !== null && data !== void 0 && data.FamilyName ? data === null || data === void 0 ? void 0 : data.FamilyName : "")), /*#__PURE__*/ React.createElement(Typography, {
        id: "customer-mobile-numer",
        fontSize: 'sm',
        fontWeight: 'normal',
        color: systemColor.lightGrey
    }, data === null || data === void 0 ? void 0 : data.MobileNumber)), (data === null || data === void 0 ? void 0 : data.MobileNumber) && /*#__PURE__*/ React.createElement(ListPagePhoneIcon, {
        id: "mobile-no",
        color: "primary",
        onClick: function (event) {
            event.stopPropagation();
            handleMobileNoPhoneCall(data === null || data === void 0 ? void 0 : data.MobileNumber);
            trackButtonClick("ButtonClickEvent", "".concat(parentComponent) + "_PhoneIcon_Click", undefined);
        }
    })) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        width: '100%',
        alignItems: "start"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        id: "registrationNo",
        color: '#1B1D21'
    }, data === null || data === void 0 ? void 0 : data.RegistrationNo), /*#__PURE__*/ React.createElement(Tooltip, {
        title: (data === null || data === void 0 ? void 0 : data.ProductName) || '',
        arrow: true
    }, /*#__PURE__*/ React.createElement(Typography, {
        width: '100%',
        fontSize: 'sm',
        fontWeight: 'normal',
        id: "product-name",
        color: systemColor.lightGrey,
        sx: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, data === null || data === void 0 ? void 0 : data.ProductName)))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "flex-start",
        justifyContent: 'end'
    }, (data === null || data === void 0 ? void 0 : data.Key) && /*#__PURE__*/ React.createElement(Chip, _extends({
        id: 'status',
        label: (data === null || data === void 0 ? void 0 : data.StatusName) || '-',
        size: "small"
    }, getStatusColor((data === null || data === void 0 ? void 0 : data.StatusName) || ''), {
        variant: "filled",
        shape: "rounded"
    })), isMoreMenuVisible && (data === null || data === void 0 ? void 0 : data.Key) && ((data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Cancelled || (data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Closed || !(data !== null && data !== void 0 && data.SourceDocumentNo) || (data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Error || (data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Awaiting || (data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Inward ? null : /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "more-menu-icon",
        onClick: handleClick,
        style: {
            height: "24px",
            width: "24px",
            paddingLeft: '12px'
        },
        disabled: (menusFeatures === null || menusFeatures === void 0 ? void 0 : menusFeatures.length) === 0
    }, /*#__PURE__*/ React.createElement("img", {
        id: "moreMenuIcon",
        src: MoreIconNew,
        alt: "settingIcon"
    }))), parentComponent == ESystemName.Estimate && (data === null || data === void 0 ? void 0 : data.Key) && ((data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Approved || (data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Created) && /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "more-menu-icon",
        onClick: handleClick,
        style: {
            height: "24px",
            width: "24px"
        },
        disabled: (menusFeatures === null || menusFeatures === void 0 ? void 0 : menusFeatures.length) === 0
    }, /*#__PURE__*/ React.createElement("img", {
        id: "moreMenuIcon",
        src: MoreIconNew,
        alt: "settingIcon"
    })), parentComponent == ESystemName.Inspection && (data === null || data === void 0 ? void 0 : data.Key) && ((data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Completed || (data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Open || (data === null || data === void 0 ? void 0 : data.Key) == StatusEnum.Converted) && /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "more-menu-icon",
        onClick: handleClick,
        style: {
            height: "24px",
            width: "24px"
        },
        disabled: (menusFeatures === null || menusFeatures === void 0 ? void 0 : menusFeatures.length) === 0
    }, /*#__PURE__*/ React.createElement("img", {
        id: "moreMenuIcon",
        src: MoreIconNew,
        alt: "settingIcon"
    })))), isOpen && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "flex-start",
        justifyContent: "flex-end",
        columnSpacing: 0.4
    }, EListCardView.Appointment == parentComponent && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: '#F4F7FA',
        borderRadius: 2,
        p: 1.5,
        gap: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        spacing: 0
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey,
            textAlign: 'left'
        }
    }, t("APPOINTMENT_DATE_COLUMN_NAME"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "scheduled-date",
        sx: {
            textAlign: 'right'
        },
        color: ' #1B1D21'
    }, data !== null && data !== void 0 && data.SlotStartTime ? dateFormate(data === null || data === void 0 ? void 0 : data.SlotStartTime) : "-"
    // data?.ScheduledDate ? new Date(data?.ScheduledDate)?.toLocaleDateString() : "-"
    , " -", data !== null && data !== void 0 && data.SlotStartTime ? getTime(data === null || data === void 0 ? void 0 : data.SlotStartTime) : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey,
            textAlign: 'left'
        }
    }, t("Registration No."), ":"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "registration-no",
        sx: {
            textAlign: 'right'
        },
        color: ' #1B1D21'
    }, data === null || data === void 0 ? void 0 : data.RegistrationNo)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey,
            textAlign: 'left'
        }
    }, t("Chassis No."), ":"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "vin-no",
        color: ' #1B1D21',
        sx: {
            textAlign: 'right'
        }
    }, data === null || data === void 0 ? void 0 : data.VinNo)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey,
            textAlign: 'left'
        }
    }, t("Vehicle"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "product-name",
        sx: {
            textAlign: 'right',
            color: '#1B1D21'
        }
    }, data === null || data === void 0 ? void 0 : data.ProductName))), EListCardView.JobCard == parentComponent && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: '#F4F7FA',
        borderRadius: 2,
        p: 1.5,
        gap: 1,
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Customer"), ":"), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'flex-start',
        spacing: 0.5,
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(ListPagePhoneIcon, {
        id: "mobile-no",
        color: "primary",
        onClick: function (event) {
            event.stopPropagation();
            handleMobileNoPhoneCall(data === null || data === void 0 ? void 0 : data.MobileNumber);
            trackButtonClick("ButtonClickEvent", "".concat(parentComponent) + "_PhoneIcon_Click", undefined);
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        id: "customerName",
        variant: "h5",
        sx: {
            color: systemColor.primary,
            textAlign: 'end'
        }
    }, "".concat(data !== null && data !== void 0 && (_data$Customer = data.Customer) !== null && _data$Customer !== void 0 && _data$Customer.GivenName ? data === null || data === void 0 || (_data$Customer2 = data.Customer) === null || _data$Customer2 === void 0 ? void 0 : _data$Customer2.GivenName : "-", " ").concat(data !== null && data !== void 0 && (_data$Customer3 = data.Customer) !== null && _data$Customer3 !== void 0 && _data$Customer3.FamilyName ? data === null || data === void 0 || (_data$Customer4 = data.Customer) === null || _data$Customer4 === void 0 ? void 0 : _data$Customer4.FamilyName : "")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("EXP_DELIVERY"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "scheduled-date"
    }, data !== null && data !== void 0 && data.DeliveryDate ? "".concat(dateFormate(data === null || data === void 0 ? void 0 : data.DeliveryDate), "  ").concat(getTime(data === null || data === void 0 ? void 0 : data.DeliveryDate)) : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Service type:")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "repair-type-name"
    }, data !== null && data !== void 0 && data.RepairTypeName ? data === null || data === void 0 ? void 0 : data.RepairTypeName : '-')), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Service Advisor:")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "service-advisor-given-name"
    }, "".concat(data !== null && data !== void 0 && data.ServiceAdvisorGivenName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorGivenName : "-", " ").concat(data !== null && data !== void 0 && data.ServiceAdvisorFamilyName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorFamilyName : "")))), ESystemName.Estimate == parentComponent && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: '#F4F7FA',
        borderRadius: 2,
        p: 1.5,
        gap: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Customer"), ":"), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'flex-start',
        spacing: 0.5,
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(ListPagePhoneIcon, {
        id: "mobile-no",
        color: "primary",
        onClick: function (event) {
            event.stopPropagation();
            handleMobileNoPhoneCall(data === null || data === void 0 ? void 0 : data.MobileNumber);
            trackButtonClick("ButtonClickEvent", "".concat(parentComponent) + "_PhoneIcon_Click", undefined);
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'medium',
        sx: {
            color: systemColor.primary,
            textAlign: 'end'
        }
    }, "".concat(data !== null && data !== void 0 && data.GivenName ? data === null || data === void 0 ? void 0 : data.GivenName : "-", " ").concat(data !== null && data !== void 0 && data.FamilyName ? data === null || data === void 0 ? void 0 : data.FamilyName : "")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        title: t("ESTIMATE_DATE_COLUMN_NAME"),
        arrow: true
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey,
            whiteSpace: 'nowrap',
            maxWidth: '50%',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
        }
    }, t("ESTIMATE_DATE_COLUMN_NAME"), ":")), /*#__PURE__*/ React.createElement(Tooltip, {
        title: data !== null && data !== void 0 && data.DeliveryDate ? "".concat(dateFormate(data === null || data === void 0 ? void 0 : data.DeliveryDate), " ").concat(getTime(data === null || data === void 0 ? void 0 : data.DeliveryDate)) : "-",
        arrow: true
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "scheduled-date",
        sx: {
            maxWidth: '50%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'right'
        }
    }, data !== null && data !== void 0 && data.DeliveryDate ? "".concat(dateFormate(data === null || data === void 0 ? void 0 : data.DeliveryDate), "  ").concat(getTime(data === null || data === void 0 ? void 0 : data.DeliveryDate)) : "-"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Service type:")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "repair-type-name",
        sx: {
            textAlign: 'end'
        }
    }, data !== null && data !== void 0 && data.RepairTypeName ? data === null || data === void 0 ? void 0 : data.RepairTypeName : '-')), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Service Advisor:")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "service-advisor-given-name"
    }, "".concat(data !== null && data !== void 0 && data.ServiceAdvisorGivenName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorGivenName : "-", " ").concat(data !== null && data !== void 0 && data.ServiceAdvisorFamilyName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorFamilyName : "")))), EListCardView.Inspection == parentComponent && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: '#F4F7FA',
        borderRadius: 2,
        p: 1.5,
        gap: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Customer"), ":"), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'flex-start',
        spacing: 0.5,
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(ListPagePhoneIcon, {
        id: "mobile-no",
        color: "primary",
        onClick: function (event) {
            event.stopPropagation();
            handleMobileNoPhoneCall(data === null || data === void 0 ? void 0 : data.MobileNumber);
            trackButtonClick("ButtonClickEvent", "".concat(parentComponent) + "_PhoneIcon_Click", undefined);
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'medium',
        sx: {
            color: systemColor.primary,
            textAlign: 'end'
            // width: (data?.GivenName + data?.FamilyName).length > 30 ? 'min-content' : 'auto'
        }
    }, "".concat(data !== null && data !== void 0 && data.GivenName ? data === null || data === void 0 ? void 0 : data.GivenName : "-", " ").concat(data !== null && data !== void 0 && data.FamilyName ? data === null || data === void 0 ? void 0 : data.FamilyName : "")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("INSPECTION_DATE_COLUMN_NAME"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "scheduled-date"
    }, data !== null && data !== void 0 && data.ScheduledDate ? dateFormate(data === null || data === void 0 ? void 0 : data.ScheduledDate) : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Service type:")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "repair-type-name",
        sx: {
            textAlign: 'end'
        }
    }, data !== null && data !== void 0 && data.RepairTypeName ? data === null || data === void 0 ? void 0 : data.RepairTypeName : '-')), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Service Advisor:")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "service-advisor-given-name"
    }, "".concat(data !== null && data !== void 0 && data.ServiceAdvisorGivenName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorGivenName : "-", " ").concat(data !== null && data !== void 0 && data.ServiceAdvisorFamilyName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorFamilyName : "")))), EListCardView.finalInspector == parentComponent && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: '#F4F7FA',
        borderRadius: 2,
        p: 1.5,
        gap: 1,
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Customer"), ":"), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'flex-start',
        spacing: 0.5,
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(ListPagePhoneIcon, {
        id: "mobile-no",
        color: "primary",
        onClick: function (event) {
            event.stopPropagation();
            handleMobileNoPhoneCall(data === null || data === void 0 ? void 0 : data.MobileNumber);
            trackButtonClick("ButtonClickEvent", "".concat(parentComponent) + "_PhoneIcon_Click", undefined);
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.primary
        }
    }, "".concat(data !== null && data !== void 0 && data.GivenName ? data === null || data === void 0 ? void 0 : data.GivenName : "-", " ").concat(data !== null && data !== void 0 && data.FamilyName ? data === null || data === void 0 ? void 0 : data.FamilyName : "")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("ETD"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium'
    }, data !== null && data !== void 0 && data.ETDDate ? dateFormate(data === null || data === void 0 ? void 0 : data.ETDDate) : "-", " - ", data !== null && data !== void 0 && data.ETDTime ? getTimeString((_data$ETDDateTime = data === null || data === void 0 ? void 0 : data.ETDDateTime) !== null && _data$ETDDateTime !== void 0 ? _data$ETDDateTime : "") : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Service type:")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        id: "repair-type-name"
    }, data !== null && data !== void 0 && data.RepairTypeName ? data === null || data === void 0 ? void 0 : data.RepairTypeName : '-')), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium',
        sx: {
            color: systemColor.lightGrey
        }
    }, t("Service Advisor:")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'sm',
        fontWeight: 'medium'
    }, "".concat(data !== null && data !== void 0 && data.ServiceAdvisorGivenName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorGivenName : "-", " ").concat(data !== null && data !== void 0 && data.ServiceAdvisorFamilyName ? data === null || data === void 0 ? void 0 : data.ServiceAdvisorFamilyName : ""))))), showViewDetailsButton && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        onClick: onCardClick,
        fullWidth: true,
        variant: "outlined",
        name: "View details",
        size: "medium",
        sx: {
            color: bajajPrimaryBlue
        },
        endIcon: /*#__PURE__*/ React.createElement("img", {
            src: RightArrowIconBlue
        })
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        mt: '4px',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, data === null || data === void 0 || (_data$Alerts = data.Alerts) === null || _data$Alerts === void 0 ? void 0 : _data$Alerts.map(function (alertItem, index) {
        return /*#__PURE__*/ React.createElement(Box, {
            key: index,
            sx: {
                display: 'inline-flex',
                justifyContent: 'space-evenly',
                borderRadius: '6px',
                backgroundColor: '#FFF7E5',
                placeItems: 'center',
                width: '75px',
                height: '22px'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            color: '#CC7A00',
            variant: "h3"
        }, alertItem.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : alertItem.AlertName));
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "view-more",
        sx: {
            color: systemColor.darkGrey,
            fontWeight: "500px",
            cursor: "pointer"
        },
        variant: "h6",
        onClick: function () { return setIsOpen(!isOpen); }
    }, "View ", isOpen ? 'Less' : 'More'), isOpen ? /*#__PURE__*/ React.createElement(KeyboardArrowUp, {
        id: "view-more-icon",
        sx: {
            color: systemColor.darkGrey,
            cursor: "pointer"
        },
        onClick: function () { return setIsOpen(!isOpen); }
    }) : /*#__PURE__*/ React.createElement(KeyboardArrowDown, {
        sx: {
            color: systemColor.darkGrey,
            cursor: "pointer"
        },
        onClick: function () { return setIsOpen(!isOpen); }
    })))));
}
